module.exports = __webpack_public_path__ + "static/img/publicity-icon5.3915613.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-icon5.png
// module id = npYN
// module chunks = 1